import { Injectable } from '@angular/core';
import { TokenClaims } from '@azure/msal-common/browser';
import { Permission } from '../../interfaces/permission.pojo';
import { ZeissIdContact } from '../../interfaces/zeissid-contact.interface';
import { ZeissIdCustomFields } from '../../interfaces/zeissid-customfields.interface';
import { ZeissIdOrganisation } from '../../interfaces/zeissid-organisation.interface';
import { ZeissIdUser } from '../../interfaces/zeissid-user.interface';

@Injectable({
  providedIn: 'root',
})
export class Token {
  extractFromClaims(
    idTokenClaims: (TokenClaims & { [key: string]: unknown }) | undefined,
  ): ExtractedTokens {
    return {
      tokenBase: idTokenClaims?.['ZeissIdBase'] as string | undefined,
      tokenContact: idTokenClaims?.['ZeissIdContact'] as string | undefined,
      tokenOrganisation: idTokenClaims?.['ZeissIdOrganisation'] as
        | string
        | undefined,
      tokenCustomFields: idTokenClaims?.['ZeissIdCustomFields'] as
        | string
        | undefined,
    };
  }

  isValidTokenSet(tokens: ExtractedTokens): boolean {
    return Boolean(
      tokens.tokenBase && tokens.tokenContact && tokens.tokenOrganisation,
    );
  }

  parseAndMerge(
    tokenBase: string,
    tokenContact: string,
    tokenOrganisation: string,
  ): ZeissIdUser & ZeissIdContact & ZeissIdOrganisation {
    const zeissIdUser = JSON.parse(tokenBase) as ZeissIdUser;
    const zeissIdContact = JSON.parse(tokenContact) as ZeissIdContact;
    const zeissIdOrganisation = JSON.parse(
      tokenOrganisation,
    ) as ZeissIdOrganisation;

    return {
      ...zeissIdUser,
      ...zeissIdContact,
      ...zeissIdOrganisation,
    };
  }

  parsePermissions(tokenCustomFields?: string): Permission[] {
    if (!tokenCustomFields) {
      return [];
    }

    try {
      const customFields = JSON.parse(tokenCustomFields) as ZeissIdCustomFields;
      const permissions: Permission[] = [];

      if (
        customFields.vis_lr_owner &&
        customFields.vis_lr_owner.trim() !== ''
      ) {
        // Versuche den Wert als Permission zu parsen
        const permissionValue = customFields.vis_lr_owner.trim();
        if (Object.values(Permission).includes(permissionValue as Permission)) {
          permissions.push(permissionValue as Permission);
        }
      }

      return permissions;
    } catch (error) {
      console.error('Failed to parse custom fields:', error);
      return [];
    }
  }
}
